import React, { useState } from "react";
import { Col, Container, Row, Card, CardBody, Table } from "reactstrap";
import ProfileSettings from "./ProfileSettings";
import ChangePassword from "./ChangePassword";
import RolesPermissions from "./RolesPermissions";
import GymSettings from "./GymSettings";

export default function Setting() {
  const [activeCard, setActiveCard] = useState("profileSettings");

  return (
    <div className="">
      <Container fluid>
        <Row className="g-2">
          <Col md={4}>
            <Card className="rounded-4" style={{ minHeight: "550px" }}>
              <CardBody>
                <Table>
                  <thead>
                    <span className="font-size-20 ff-sora fw-bold primary-black">
                      Settings
                    </span>
                  </thead>
                  <tbody style={{ minHeight: "550px" }}>
                    <tr
                      onClick={() => setActiveCard("profileSettings")}
                      style={{ cursor: "pointer" }}
                    >
                      <td className="font-size-16 fw-normal ff-sora secondary-black">
                        Profile Settings
                      </td>
                    </tr>

                    <tr
                      onClick={() => setActiveCard("changePassword")}
                      style={{ cursor: "pointer" }}
                    >
                      <td className="font-size-16 fw-normal ff-sora secondary-black">
                        Change Password
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
          <Col md={8}>
            {activeCard === "profileSettings" && <ProfileSettings />}
            {activeCard === "gymSettings" && <GymSettings />}
            {activeCard === "changePassword" && <ChangePassword />}
            {activeCard === "rolesPermissions" && <RolesPermissions />}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
